/* global window */
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from '@gasbuddy/web-dev/hot';
import { entryPoint } from '@gasbuddy/react';
import { Router } from '../common/router';
import appReducer from '../common/reducers';

// Global styles for admin
import './css/admin.css';

let router = Router;
if (process.env.NODE_ENV !== 'production') {
  router = hot(module)(Router);
}

entryPoint({
  router,
  reducers: appReducer,
  initialState: window.PreloadedState,
});
